import { useQuotation } from '../context'
import formatPrice from '../../utils/formatPrice'

import { OnboardingTitle } from './OnboardingTitle'

import { Hint, Select } from '@olino/design-system'

const deductibleAmounts = [500, 750, 1_000]

export const PricingMREAcheelDeductibleSlider: React.FC = () => {
  const { quotation, updateQuotation } = useQuotation()

  const details = quotation.details.mreAcheel

  return (
    <div className="flex items-center gap-3">
      <OnboardingTitle.H3Pricing>Montant de votre franchise :</OnboardingTitle.H3Pricing>

      <Select
        className="min-w-[180px]"
        options={deductibleAmounts}
        value={details?.deductibleAmount || 1_000}
        getOptionLabel={(value) => formatPrice(value, 0)}
        onChange={(value) =>
          updateQuotation({
            details: {
              mreAcheel: {
                deductibleAmount: value,
              },
            },
          })
        }
      />

      <Hint>
        Le <span className="font-semibold">montant de la franchise</span> correspond au reste à
        charge qu'il vous faudra régler en cas de sinistre. Vous pouvez le modifier.
      </Hint>
    </div>
  )
}
